/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateBotStrategyByIdOptions,
  CreateBotStrategyByIdStatus201,
  CreateBotStrategyByIdStatus400,
  CreateBotStrategyByIdStatus500,
} from '../types/CreateBotStrategyById'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createBotStrategyById } from '../clients/createBotStrategyById'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createBotStrategyByIdMutationKey = () => [{ url: '/v1/bot/strategies' }] as const

export function createBotStrategyByIdMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createBotStrategyByIdMutationKey()
  return mutationOptions<
    CreateBotStrategyByIdStatus201,
    ResponseErrorConfig<CreateBotStrategyByIdStatus400 | CreateBotStrategyByIdStatus500>,
    CreateBotStrategyByIdOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createBotStrategyById({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Create a new bot strategy. Admin-only.
 * @summary Create Bot Strategy
 * {@link /v1/bot/strategies}
 */
export function useCreateBotStrategyById<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateBotStrategyByIdStatus201,
      ResponseErrorConfig<CreateBotStrategyByIdStatus400 | CreateBotStrategyByIdStatus500>,
      CreateBotStrategyByIdOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createBotStrategyByIdMutationKey()

  const baseOptions = createBotStrategyByIdMutationOptions(config) as UseMutationOptions<
    CreateBotStrategyByIdStatus201,
    ResponseErrorConfig<CreateBotStrategyByIdStatus400 | CreateBotStrategyByIdStatus500>,
    CreateBotStrategyByIdOptions,
    TContext
  >

  return useMutation<
    CreateBotStrategyByIdStatus201,
    ResponseErrorConfig<CreateBotStrategyByIdStatus400 | CreateBotStrategyByIdStatus500>,
    CreateBotStrategyByIdOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateBotStrategyByIdStatus201,
    ResponseErrorConfig<CreateBotStrategyByIdStatus400 | CreateBotStrategyByIdStatus500>,
    CreateBotStrategyByIdOptions,
    TContext
  >
}
